import $ from 'jquery';
import { makeRequest } from './request';

function inputAlertClosing() {
    const input = $('.input');

    input.on('click', function () {
        $(this).find('.alert-input').css('opacity', '0');
    });
}

function boxAlertClosing() {
    const trigger = $('.alert__close');

    trigger.on('click', function () {
        // console.log('clicked');
        $('.alert__fixed').addClass('-closed');
    });

    $('.alert__fixed.is-unclosable a').on('click', function () {
        $('.alert__fixed').addClass('-closed');
    });

    setTimeout(function () {
        $('.alert__fixed').addClass('-closed');
    }, 2000);

}

function init() {
    $('.input').each(inputAlertClosing);

    $('.alert').each(boxAlertClosing);

    if ($('.alert').length > 0) {
        $('.alert__fixed').removeClass('-closed');
    }

    if ($('.alert__fixed').hasClass('is-unclosable')) {
        setTimeout(function () {
            $('.alert__fixed').removeClass('-closed');
        }, 2000);
    }

}

export {init};



// WEBPACK FOOTER //
// ./src/_app/layout/alerts.js